import { actionTypes } from '../actions';
import { API_NOTIFICATION_TYPE } from '../components/api-notifications';

export default (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.ADD_NOTIFICATION: {
      const { reloadRequired = true, iconClassName, id, message, type: notificationType, dismissAfter } = payload;

      return [...state, {
        reloadRequired: !!reloadRequired,
        id,
        message,
        iconClassName: iconClassName || 'fa fa-exclamation-circle',
        type: notificationType || API_NOTIFICATION_TYPE.DANGER,
        dismissAfter: dismissAfter || 3000,
      }];
    }

    case actionTypes.REMOVE_NOTIFICATION: {
      const { notificationId } = payload;

      return state.filter((notification) => notification.id !== notificationId);
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/api-notifications.js